/*
 * @Author: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @Date: 2025-04-02 09:59:03
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-04-08 14:19:12
 */
import React from 'react'
import { Tooltip } from 'antd'
import desktopLib from '../../../utils/desktopLib'
import photoResultFeedbackIcon from '../../../images/photo-result-feedback-icon.png'

interface SearchFeedbackProps {
  onFeedbackClick?: () => void // 添加一个可选的回调函数属性
}

const SearchFeedback: React.FC<SearchFeedbackProps> = ({ onFeedbackClick }) => {
  const handleFeedbackClick = () => {
    // 调用父组件传入的埋点方法（如果存在）
    if (onFeedbackClick) {
      onFeedbackClick()
    }

    // 原有的打开问卷逻辑
    if (desktopLib.isDesktop) {
      desktopLib.openContact(
        'https://wynvrr4htp.feishu.cn/share/base/form/shrcnoTUGufUEbW08tBZ7PazZ2d'
      )
    } else {
      window.open(
        'https://wynvrr4htp.feishu.cn/share/base/form/shrcnoTUGufUEbW08tBZ7PazZ2d',
        '_blank'
      )
    }
  }

  return (
    <Tooltip title="搜索反馈">
      <span
        style={{
          marginLeft: '10px'
        }}
        onClick={handleFeedbackClick}
      >
        <img
          src={photoResultFeedbackIcon}
          style={{
            width: '18px',
            height: '18px',
            verticalAlign: 'sub'
          }}
          alt=""
        />
      </span>
    </Tooltip>
  )
}

export default SearchFeedback
